import { DesktopSettingsType } from './shared-types.js'

export function getDefaultState(): DesktopSettingsType {
  /**
   * Persisted state. Must be JSON.
   */
  return {
    bounds: {},
    HTMLEmailWindowBounds: undefined,
    enterKeySends: false,
    notifications: true,
    showNotificationContent: true,
    locale: null, // if this is null, the system chooses the system language that electron reports
    credentials: undefined,
    lastAccount: undefined,
    enableOnDemandLocationStreaming: false,
    linkPreviewSuggestions: false,
    stripTrackingLinks: true,
    experimentalCompletionMenu: true,
    experimentalUnreadReadTime: false,
    experimentalAudioPlayerControls: true,
    voiceMessageMediaSessionDetails: false,
    voiceRecordingOriginalAudio: false,
    voiceRecordingDeviceId: undefined,
    chatViewBgImg: undefined,
    lastChats: {},
    zoomFactor: undefined,
    activeTheme: 'system',
    minimizeToTray: true,
    syncAllAccounts: true,
    lastSaveDialogLocation: undefined,
    enableWebxdcDevTools: false,
    HTMLEmailAskForRemoteLoadingConfirmation: true,
    HTMLEmailAlwaysLoadRemoteContent: false,
    galleryImageKeepAspectRatio: false,
    useSystemUIFont: false,
    contentProtectionEnabled: false,
    inChatSoundsVolume: 0.5,
    autostart: true,
    autostartElectron: false,
    appStoreBaseUrl: undefined,
    hideNewChatSuggestions: false,
    publicBotsRemoteLoadConsent: false,
  }
}

export const defaultAppStoreBaseUrl = 'https://apps.testrun.org/'
